// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/registry_contract.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from enum mono.datagateway.v1.RegistryContractMeasure
 */ export var RegistryContractMeasure = /*#__PURE__*/ function(RegistryContractMeasure) {
    /**
   * @generated from enum value: REGISTRY_CONTRACT_MEASURE_UNSPECIFIED = 0;
   */ RegistryContractMeasure[RegistryContractMeasure["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_MEASURE_OBLIGATIONS = 1;
   */ RegistryContractMeasure[RegistryContractMeasure["OBLIGATIONS"] = 1] = "OBLIGATIONS";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_MEASURE_CEILING = 2;
   */ RegistryContractMeasure[RegistryContractMeasure["CEILING"] = 2] = "CEILING";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_MEASURE_CURRENT_COMPLETION_DATE = 3;
   */ RegistryContractMeasure[RegistryContractMeasure["CURRENT_COMPLETION_DATE"] = 3] = "CURRENT_COMPLETION_DATE";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_MEASURE_ULTIMATE_COMPLETION_DATE = 4;
   */ RegistryContractMeasure[RegistryContractMeasure["ULTIMATE_COMPLETION_DATE"] = 4] = "ULTIMATE_COMPLETION_DATE";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_MEASURE_ACTION_OBLIGATIONS = 5;
   */ RegistryContractMeasure[RegistryContractMeasure["ACTION_OBLIGATIONS"] = 5] = "ACTION_OBLIGATIONS";
    /**
   * DAT-01: period-of-performance start date (unit YYYY-MM-DD, period "award").
   *
   * @generated from enum value: REGISTRY_CONTRACT_MEASURE_PERIOD_START_DATE = 6;
   */ RegistryContractMeasure[RegistryContractMeasure["PERIOD_START_DATE"] = 6] = "PERIOD_START_DATE";
    return RegistryContractMeasure;
}({});
// Retrieve enum metadata with: proto3.getEnumType(RegistryContractMeasure)
proto3.util.setEnumType(RegistryContractMeasure, "mono.datagateway.v1.RegistryContractMeasure", [
    {
        no: 0,
        name: "REGISTRY_CONTRACT_MEASURE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "REGISTRY_CONTRACT_MEASURE_OBLIGATIONS"
    },
    {
        no: 2,
        name: "REGISTRY_CONTRACT_MEASURE_CEILING"
    },
    {
        no: 3,
        name: "REGISTRY_CONTRACT_MEASURE_CURRENT_COMPLETION_DATE"
    },
    {
        no: 4,
        name: "REGISTRY_CONTRACT_MEASURE_ULTIMATE_COMPLETION_DATE"
    },
    {
        no: 5,
        name: "REGISTRY_CONTRACT_MEASURE_ACTION_OBLIGATIONS"
    },
    {
        no: 6,
        name: "REGISTRY_CONTRACT_MEASURE_PERIOD_START_DATE"
    }
]);
/**
 * @generated from enum mono.datagateway.v1.RegistryContractValueState
 */ export var RegistryContractValueState = /*#__PURE__*/ function(RegistryContractValueState) {
    /**
   * @generated from enum value: REGISTRY_CONTRACT_VALUE_STATE_UNSPECIFIED = 0;
   */ RegistryContractValueState[RegistryContractValueState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_VALUE_STATE_KNOWN = 1;
   */ RegistryContractValueState[RegistryContractValueState["KNOWN"] = 1] = "KNOWN";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_VALUE_STATE_UNKNOWN = 2;
   */ RegistryContractValueState[RegistryContractValueState["UNKNOWN"] = 2] = "UNKNOWN";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_VALUE_STATE_NOT_APPLICABLE = 3;
   */ RegistryContractValueState[RegistryContractValueState["NOT_APPLICABLE"] = 3] = "NOT_APPLICABLE";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_VALUE_STATE_RETRIEVAL_FAILURE = 4;
   */ RegistryContractValueState[RegistryContractValueState["RETRIEVAL_FAILURE"] = 4] = "RETRIEVAL_FAILURE";
    return RegistryContractValueState;
}({});
// Retrieve enum metadata with: proto3.getEnumType(RegistryContractValueState)
proto3.util.setEnumType(RegistryContractValueState, "mono.datagateway.v1.RegistryContractValueState", [
    {
        no: 0,
        name: "REGISTRY_CONTRACT_VALUE_STATE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "REGISTRY_CONTRACT_VALUE_STATE_KNOWN"
    },
    {
        no: 2,
        name: "REGISTRY_CONTRACT_VALUE_STATE_UNKNOWN"
    },
    {
        no: 3,
        name: "REGISTRY_CONTRACT_VALUE_STATE_NOT_APPLICABLE"
    },
    {
        no: 4,
        name: "REGISTRY_CONTRACT_VALUE_STATE_RETRIEVAL_FAILURE"
    }
]);
/**
 * @generated from enum mono.datagateway.v1.RegistryContractDecision
 */ export var RegistryContractDecision = /*#__PURE__*/ function(RegistryContractDecision) {
    /**
   * @generated from enum value: REGISTRY_CONTRACT_DECISION_UNSPECIFIED = 0;
   */ RegistryContractDecision[RegistryContractDecision["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_DECISION_PROPOSAL = 1;
   */ RegistryContractDecision[RegistryContractDecision["PROPOSAL"] = 1] = "PROPOSAL";
    /**
   * @generated from enum value: REGISTRY_CONTRACT_DECISION_COMMIT = 2;
   */ RegistryContractDecision[RegistryContractDecision["COMMIT"] = 2] = "COMMIT";
    return RegistryContractDecision;
}({});
// Retrieve enum metadata with: proto3.getEnumType(RegistryContractDecision)
proto3.util.setEnumType(RegistryContractDecision, "mono.datagateway.v1.RegistryContractDecision", [
    {
        no: 0,
        name: "REGISTRY_CONTRACT_DECISION_UNSPECIFIED"
    },
    {
        no: 1,
        name: "REGISTRY_CONTRACT_DECISION_PROPOSAL"
    },
    {
        no: 2,
        name: "REGISTRY_CONTRACT_DECISION_COMMIT"
    }
]);
/**
 * @generated from message mono.datagateway.v1.ListContactConnectedWorkRequest
 */ export class ListContactConnectedWorkRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContactConnectedWorkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactConnectedWorkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactConnectedWorkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactConnectedWorkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactConnectedWorkRequest, "runtime", proto3);
_define_property(ListContactConnectedWorkRequest, "typeName", "mono.datagateway.v1.ListContactConnectedWorkRequest");
_define_property(ListContactConnectedWorkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContactConnectedWork
 */ export class ContactConnectedWork extends Message {
    static fromBinary(bytes, options) {
        return new ContactConnectedWork().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactConnectedWork().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactConnectedWork().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactConnectedWork, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string type = 2;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string context_id = 3;
   */ _define_property(this, "contextId", ""), /**
   * @generated from field: string context_name = 4;
   */ _define_property(this, "contextName", ""), /**
   * @generated from field: string role = 5;
   */ _define_property(this, "role", ""), /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 6;
   */ _define_property(this, "occurredAt", void 0), /**
   * @generated from field: string historical_organization = 7;
   */ _define_property(this, "historicalOrganization", ""), /**
   * Local owner path only; clients append their validated return context.
   *
   * @generated from field: string owner_path = 8;
   */ _define_property(this, "ownerPath", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactConnectedWork, "runtime", proto3);
_define_property(ContactConnectedWork, "typeName", "mono.datagateway.v1.ContactConnectedWork");
_define_property(ContactConnectedWork, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "context_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "context_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "occurred_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "historical_organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "owner_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactConnectedWorkResponse
 */ export class ListContactConnectedWorkResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContactConnectedWorkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactConnectedWorkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactConnectedWorkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactConnectedWorkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContactConnectedWork items = 1;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactConnectedWorkResponse, "runtime", proto3);
_define_property(ListContactConnectedWorkResponse, "typeName", "mono.datagateway.v1.ListContactConnectedWorkResponse");
_define_property(ListContactConnectedWorkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: ContactConnectedWork,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractIdentity
 */ export class RegistryContractIdentity extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractIdentity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractIdentity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractIdentity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractIdentity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string piid = 1;
   */ _define_property(this, "piid", ""), /**
   * @generated from field: string agency = 2;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: string subtier = 3;
   */ _define_property(this, "subtier", ""), /**
   * @generated from field: string referenced_idv = 4;
   */ _define_property(this, "referencedIdv", ""), /**
   * vehicle_mechanism, holder_contract, task_order, delivery_order
   *
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", ""), /**
   * prime, subcontract
   *
   * @generated from field: string role = 6;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string party_key = 7;
   */ _define_property(this, "partyKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractIdentity, "runtime", proto3);
_define_property(RegistryContractIdentity, "typeName", "mono.datagateway.v1.RegistryContractIdentity");
_define_property(RegistryContractIdentity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "piid",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "subtier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "referenced_idv",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "party_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractRefs
 */ export class RegistryContractRefs extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractRefs().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractRefs().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractRefs().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractRefs, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string company_id = 1;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string government_org_id = 2;
   */ _define_property(this, "governmentOrgId", ""), /**
   * @generated from field: string vehicle_id = 3;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string parent_id = 4;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: string rate_observation_id = 5;
   */ _define_property(this, "rateObservationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractRefs, "runtime", proto3);
_define_property(RegistryContractRefs, "typeName", "mono.datagateway.v1.RegistryContractRefs");
_define_property(RegistryContractRefs, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "government_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rate_observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractRecord
 */ export class RegistryContractRecord extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractRecord, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryContractIdentity identity = 2;
   */ _define_property(this, "identity", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryContractRefs refs = 3;
   */ _define_property(this, "refs", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0), /**
   * Detail-only canonical summary, after all reference/source permission checks.
   *
   * @generated from field: mono.datagateway.v1.RegistryContractRateLink associated_rate = 5;
   */ _define_property(this, "associatedRate", void 0), /**
   * DAT-01 award classification (NAICS / PSC / set-aside), newest source wins.
   *
   * @generated from field: mono.datagateway.v1.RegistryContractClassification classification = 6;
   */ _define_property(this, "classification", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractRecord, "runtime", proto3);
_define_property(RegistryContractRecord, "typeName", "mono.datagateway.v1.RegistryContractRecord");
_define_property(RegistryContractRecord, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "identity",
            kind: "message",
            T: RegistryContractIdentity
        },
        {
            no: 3,
            name: "refs",
            kind: "message",
            T: RegistryContractRefs
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "associated_rate",
            kind: "message",
            T: RegistryContractRateLink
        },
        {
            no: 6,
            name: "classification",
            kind: "message",
            T: RegistryContractClassification
        }
    ]));
/**
 * Award classification columns (DAT-01 migration 004583). Codes are as the
 * source published them; descriptions are the public code-list labels.
 *
 * @generated from message mono.datagateway.v1.RegistryContractClassification
 */ export class RegistryContractClassification extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractClassification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractClassification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractClassification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractClassification, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string naics_code = 1;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: string naics_description = 2;
   */ _define_property(this, "naicsDescription", ""), /**
   * @generated from field: string psc_code = 3;
   */ _define_property(this, "pscCode", ""), /**
   * @generated from field: string psc_description = 4;
   */ _define_property(this, "pscDescription", ""), /**
   * FPDS code verbatim, e.g. SBA, 8AN, SDVOSBC, NONE
   *
   * @generated from field: string set_aside_code = 5;
   */ _define_property(this, "setAsideCode", ""), /**
   * @generated from field: string set_aside_description = 6;
   */ _define_property(this, "setAsideDescription", ""), /**
   * NONE | SMALL_BUSINESS | EIGHT_A | HUBZONE | SDVOSB | WOSB | VOSB | OTHER | UNKNOWN
   *
   * @generated from field: string set_aside_kind = 7;
   */ _define_property(this, "setAsideKind", ""), /**
   * "" | usaspending | sam_awards
   *
   * @generated from field: string classification_source = 8;
   */ _define_property(this, "classificationSource", ""), /**
   * @generated from field: google.protobuf.Timestamp classification_observed_at = 9;
   */ _define_property(this, "classificationObservedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractClassification, "runtime", proto3);
_define_property(RegistryContractClassification, "typeName", "mono.datagateway.v1.RegistryContractClassification");
_define_property(RegistryContractClassification, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "naics_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "psc_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "psc_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "set_aside_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "set_aside_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "set_aside_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "classification_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "classification_observed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractRateLink
 */ export class RegistryContractRateLink extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractRateLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractRateLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractRateLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractRateLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string lcat_entry_id = 2;
   */ _define_property(this, "lcatEntryId", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractRateLink, "runtime", proto3);
_define_property(RegistryContractRateLink, "typeName", "mono.datagateway.v1.RegistryContractRateLink");
_define_property(RegistryContractRateLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractFactKey
 */ export class RegistryContractFactKey extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractFactKey().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractFactKey().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractFactKey().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractFactKey, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryContractMeasure measure = 1;
   */ _define_property(this, "measure", 0), /**
   * Actual workshare/entity and exact period; never defaulted or wildcarded.
   *
   * @generated from field: string scope = 2;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string period = 3;
   */ _define_property(this, "period", ""), /**
   * ISO currency for money; YYYY-MM-DD for dates
   *
   * @generated from field: string unit = 4;
   */ _define_property(this, "unit", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractFactKey, "runtime", proto3);
_define_property(RegistryContractFactKey, "typeName", "mono.datagateway.v1.RegistryContractFactKey");
_define_property(RegistryContractFactKey, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "measure",
            kind: "enum",
            T: proto3.getEnumType(RegistryContractMeasure)
        },
        {
            no: 2,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractFactValue
 */ export class RegistryContractFactValue extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractFactValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractFactValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractFactValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractFactValue, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryContractValueState state = 1;
   */ _define_property(this, "state", 0), /**
   * @generated from oneof mono.datagateway.v1.RegistryContractFactValue.value
   */ _define_property(this, "value", {
            case: undefined
        });
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractFactValue, "runtime", proto3);
_define_property(RegistryContractFactValue, "typeName", "mono.datagateway.v1.RegistryContractFactValue");
_define_property(RegistryContractFactValue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state",
            kind: "enum",
            T: proto3.getEnumType(RegistryContractValueState)
        },
        {
            no: 2,
            name: "decimal",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            oneof: "value"
        },
        {
            no: 3,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            oneof: "value"
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractObservation
 */ export class RegistryContractObservation extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractObservation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractObservation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractObservation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractObservation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string source = 2;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_record_id = 3;
   */ _define_property(this, "sourceRecordId", ""), /**
   * @generated from field: string source_version = 4;
   */ _define_property(this, "sourceVersion", ""), /**
   * @generated from field: string modification_id = 5;
   */ _define_property(this, "modificationId", ""), /**
   * @generated from field: string action_id = 6;
   */ _define_property(this, "actionId", ""), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 7;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_at = 8;
   */ _define_property(this, "effectiveAt", void 0), /**
   * @generated from field: string source_location = 9;
   */ _define_property(this, "sourceLocation", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryContractIdentity identity = 10;
   */ _define_property(this, "identity", void 0), /**
   * @generated from field: string original_json = 11;
   */ _define_property(this, "originalJson", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryContractFactKey key = 12;
   */ _define_property(this, "key", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryContractFactValue fact = 13;
   */ _define_property(this, "fact", void 0), /**
   * @generated from field: string artifact_id = 14;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string artifact_version_id = 15;
   */ _define_property(this, "artifactVersionId", ""), /**
   * @generated from field: int32 page = 16;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string section = 17;
   */ _define_property(this, "section", ""), /**
   * @generated from field: string quote = 18;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractObservation, "runtime", proto3);
_define_property(RegistryContractObservation, "typeName", "mono.datagateway.v1.RegistryContractObservation");
_define_property(RegistryContractObservation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "action_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "effective_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "source_location",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "identity",
            kind: "message",
            T: RegistryContractIdentity
        },
        {
            no: 11,
            name: "original_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "key",
            kind: "message",
            T: RegistryContractFactKey
        },
        {
            no: 13,
            name: "fact",
            kind: "message",
            T: RegistryContractFactValue
        },
        {
            no: 14,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegistryContractEvidenceRecord
 */ export class RegistryContractEvidenceRecord extends Message {
    static fromBinary(bytes, options) {
        return new RegistryContractEvidenceRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryContractEvidenceRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryContractEvidenceRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryContractEvidenceRecord, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string observation_id = 2;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: string provenance_id = 3;
   */ _define_property(this, "provenanceId", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryContractFactKey key = 4;
   */ _define_property(this, "key", void 0), /**
   * @generated from field: bool proposal = 5;
   */ _define_property(this, "proposal", false), /**
   * @generated from field: string actor = 6;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string rationale = 7;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryContractEvidenceRecord, "runtime", proto3);
_define_property(RegistryContractEvidenceRecord, "typeName", "mono.datagateway.v1.RegistryContractEvidenceRecord");
_define_property(RegistryContractEvidenceRecord, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "provenance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "key",
            kind: "message",
            T: RegistryContractFactKey
        },
        {
            no: 5,
            name: "proposal",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BrowseRegistryContractsRequest
 */ export class BrowseRegistryContractsRequest extends Message {
    static fromBinary(bytes, options) {
        return new BrowseRegistryContractsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowseRegistryContractsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowseRegistryContractsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowseRegistryContractsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string piid = 1;
   */ _define_property(this, "piid", ""), /**
   * @generated from field: string after_id = 2;
   */ _define_property(this, "afterId", ""), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BrowseRegistryContractsRequest, "runtime", proto3);
_define_property(BrowseRegistryContractsRequest, "typeName", "mono.datagateway.v1.BrowseRegistryContractsRequest");
_define_property(BrowseRegistryContractsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "piid",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BrowseRegistryContractsResponse
 */ export class BrowseRegistryContractsResponse extends Message {
    static fromBinary(bytes, options) {
        return new BrowseRegistryContractsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowseRegistryContractsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowseRegistryContractsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowseRegistryContractsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryContractRecord contracts = 1;
   */ _define_property(this, "contracts", []), /**
   * Last returned authorized row, set only when another authorized row exists.
   *
   * @generated from field: string next_after_id = 2;
   */ _define_property(this, "nextAfterId", ""), /**
   * Exact authorized total for this filter, present only when the first page
   * exhausts the results. Absent means unknown, not zero or the page length.
   *
   * @generated from field: optional int64 total = 3;
   */ _define_property(this, "total", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BrowseRegistryContractsResponse, "runtime", proto3);
_define_property(BrowseRegistryContractsResponse, "typeName", "mono.datagateway.v1.BrowseRegistryContractsResponse");
_define_property(BrowseRegistryContractsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contracts",
            kind: "message",
            T: RegistryContractRecord,
            repeated: true
        },
        {
            no: 2,
            name: "next_after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRegistryContractRequest
 */ export class GetRegistryContractRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRegistryContractRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRegistryContractRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRegistryContractRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRegistryContractRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRegistryContractRequest, "runtime", proto3);
_define_property(GetRegistryContractRequest, "typeName", "mono.datagateway.v1.GetRegistryContractRequest");
_define_property(GetRegistryContractRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRegistryContractResponse
 */ export class GetRegistryContractResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRegistryContractResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRegistryContractResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRegistryContractResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRegistryContractResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryContractRecord contract = 1;
   */ _define_property(this, "contract", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRegistryContractResponse, "runtime", proto3);
_define_property(GetRegistryContractResponse, "typeName", "mono.datagateway.v1.GetRegistryContractResponse");
_define_property(GetRegistryContractResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract",
            kind: "message",
            T: RegistryContractRecord
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRegistryContractRequest
 */ export class CreateRegistryContractRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRegistryContractRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRegistryContractRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRegistryContractRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRegistryContractRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryContractIdentity identity = 1;
   */ _define_property(this, "identity", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryContractRefs refs = 2;
   */ _define_property(this, "refs", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRegistryContractRequest, "runtime", proto3);
_define_property(CreateRegistryContractRequest, "typeName", "mono.datagateway.v1.CreateRegistryContractRequest");
_define_property(CreateRegistryContractRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "identity",
            kind: "message",
            T: RegistryContractIdentity
        },
        {
            no: 2,
            name: "refs",
            kind: "message",
            T: RegistryContractRefs
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRegistryContractResponse
 */ export class CreateRegistryContractResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRegistryContractResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRegistryContractResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRegistryContractResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRegistryContractResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryContractRecord contract = 1;
   */ _define_property(this, "contract", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRegistryContractResponse, "runtime", proto3);
_define_property(CreateRegistryContractResponse, "typeName", "mono.datagateway.v1.CreateRegistryContractResponse");
_define_property(CreateRegistryContractResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract",
            kind: "message",
            T: RegistryContractRecord
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateRegistryContractRefsRequest
 */ export class UpdateRegistryContractRefsRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRegistryContractRefsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRegistryContractRefsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRegistryContractRefsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRegistryContractRefsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryContractRefs refs = 2;
   */ _define_property(this, "refs", void 0), /**
   * @generated from field: string rationale = 3;
   */ _define_property(this, "rationale", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRegistryContractRefsRequest, "runtime", proto3);
_define_property(UpdateRegistryContractRefsRequest, "typeName", "mono.datagateway.v1.UpdateRegistryContractRefsRequest");
_define_property(UpdateRegistryContractRefsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "refs",
            kind: "message",
            T: RegistryContractRefs
        },
        {
            no: 3,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateRegistryContractRefsResponse
 */ export class UpdateRegistryContractRefsResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRegistryContractRefsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRegistryContractRefsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRegistryContractRefsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRegistryContractRefsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryContractRecord contract = 1;
   */ _define_property(this, "contract", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRegistryContractRefsResponse, "runtime", proto3);
_define_property(UpdateRegistryContractRefsResponse, "typeName", "mono.datagateway.v1.UpdateRegistryContractRefsResponse");
_define_property(UpdateRegistryContractRefsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract",
            kind: "message",
            T: RegistryContractRecord
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryContractEvidenceRequest
 */ export class ListRegistryContractEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryContractEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryContractEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryContractEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryContractEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_id = 1;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string after_id = 2;
   */ _define_property(this, "afterId", ""), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryContractEvidenceRequest, "runtime", proto3);
_define_property(ListRegistryContractEvidenceRequest, "typeName", "mono.datagateway.v1.ListRegistryContractEvidenceRequest");
_define_property(ListRegistryContractEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryContractEvidenceResponse
 */ export class ListRegistryContractEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryContractEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryContractEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryContractEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryContractEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryContractEvidenceRecord evidence = 1;
   */ _define_property(this, "evidence", []), /**
   * @generated from field: string next_after_id = 2;
   */ _define_property(this, "nextAfterId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryContractEvidenceResponse, "runtime", proto3);
_define_property(ListRegistryContractEvidenceResponse, "typeName", "mono.datagateway.v1.ListRegistryContractEvidenceResponse");
_define_property(ListRegistryContractEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: RegistryContractEvidenceRecord,
            repeated: true
        },
        {
            no: 2,
            name: "next_after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRegistryContractObservationRequest
 */ export class GetRegistryContractObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRegistryContractObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRegistryContractObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRegistryContractObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRegistryContractObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRegistryContractObservationRequest, "runtime", proto3);
_define_property(GetRegistryContractObservationRequest, "typeName", "mono.datagateway.v1.GetRegistryContractObservationRequest");
_define_property(GetRegistryContractObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRegistryContractObservationResponse
 */ export class GetRegistryContractObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRegistryContractObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRegistryContractObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRegistryContractObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRegistryContractObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryContractObservation observation = 1;
   */ _define_property(this, "observation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRegistryContractObservationResponse, "runtime", proto3);
_define_property(GetRegistryContractObservationResponse, "typeName", "mono.datagateway.v1.GetRegistryContractObservationResponse");
_define_property(GetRegistryContractObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observation",
            kind: "message",
            T: RegistryContractObservation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryContractObservationsRequest
 */ export class ListRegistryContractObservationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryContractObservationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryContractObservationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryContractObservationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryContractObservationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string source = 1;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_record_id = 2;
   */ _define_property(this, "sourceRecordId", ""), /**
   * @generated from field: string after_id = 3;
   */ _define_property(this, "afterId", ""), /**
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryContractObservationsRequest, "runtime", proto3);
_define_property(ListRegistryContractObservationsRequest, "typeName", "mono.datagateway.v1.ListRegistryContractObservationsRequest");
_define_property(ListRegistryContractObservationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegistryContractObservationsResponse
 */ export class ListRegistryContractObservationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRegistryContractObservationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegistryContractObservationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegistryContractObservationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegistryContractObservationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RegistryContractObservation observations = 1;
   */ _define_property(this, "observations", []), /**
   * @generated from field: string next_after_id = 2;
   */ _define_property(this, "nextAfterId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegistryContractObservationsResponse, "runtime", proto3);
_define_property(ListRegistryContractObservationsResponse, "typeName", "mono.datagateway.v1.ListRegistryContractObservationsResponse");
_define_property(ListRegistryContractObservationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observations",
            kind: "message",
            T: RegistryContractObservation,
            repeated: true
        },
        {
            no: 2,
            name: "next_after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveRegistryContractFactRequest
 */ export class ResolveRegistryContractFactRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveRegistryContractFactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveRegistryContractFactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveRegistryContractFactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveRegistryContractFactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_id = 1;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryContractFactKey key = 2;
   */ _define_property(this, "key", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveRegistryContractFactRequest, "runtime", proto3);
_define_property(ResolveRegistryContractFactRequest, "typeName", "mono.datagateway.v1.ResolveRegistryContractFactRequest");
_define_property(ResolveRegistryContractFactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "key",
            kind: "message",
            T: RegistryContractFactKey
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveRegistryContractFactResponse
 */ export class ResolveRegistryContractFactResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveRegistryContractFactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveRegistryContractFactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveRegistryContractFactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveRegistryContractFactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryContractEvidenceRecord evidence = 1;
   */ _define_property(this, "evidence", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryContractObservation observation = 2;
   */ _define_property(this, "observation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveRegistryContractFactResponse, "runtime", proto3);
_define_property(ResolveRegistryContractFactResponse, "typeName", "mono.datagateway.v1.ResolveRegistryContractFactResponse");
_define_property(ResolveRegistryContractFactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: RegistryContractEvidenceRecord
        },
        {
            no: 2,
            name: "observation",
            kind: "message",
            T: RegistryContractObservation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WriteRegistryContractFactRequest
 */ export class WriteRegistryContractFactRequest extends Message {
    static fromBinary(bytes, options) {
        return new WriteRegistryContractFactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteRegistryContractFactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteRegistryContractFactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteRegistryContractFactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_id = 1;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string retry_key = 2;
   */ _define_property(this, "retryKey", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryContractFactKey key = 3;
   */ _define_property(this, "key", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryContractFactValue fact = 4;
   */ _define_property(this, "fact", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryContractDecision decision = 5;
   */ _define_property(this, "decision", 0), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_at = 7;
   */ _define_property(this, "effectiveAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteRegistryContractFactRequest, "runtime", proto3);
_define_property(WriteRegistryContractFactRequest, "typeName", "mono.datagateway.v1.WriteRegistryContractFactRequest");
_define_property(WriteRegistryContractFactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "retry_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "key",
            kind: "message",
            T: RegistryContractFactKey
        },
        {
            no: 4,
            name: "fact",
            kind: "message",
            T: RegistryContractFactValue
        },
        {
            no: 5,
            name: "decision",
            kind: "enum",
            T: proto3.getEnumType(RegistryContractDecision)
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "effective_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WriteRegistryContractFactResponse
 */ export class WriteRegistryContractFactResponse extends Message {
    static fromBinary(bytes, options) {
        return new WriteRegistryContractFactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteRegistryContractFactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteRegistryContractFactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteRegistryContractFactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegistryContractEvidenceRecord evidence = 1;
   */ _define_property(this, "evidence", void 0), /**
   * @generated from field: mono.datagateway.v1.RegistryContractObservation observation = 2;
   */ _define_property(this, "observation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteRegistryContractFactResponse, "runtime", proto3);
_define_property(WriteRegistryContractFactResponse, "typeName", "mono.datagateway.v1.WriteRegistryContractFactResponse");
_define_property(WriteRegistryContractFactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: RegistryContractEvidenceRecord
        },
        {
            no: 2,
            name: "observation",
            kind: "message",
            T: RegistryContractObservation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLandscapeProgramReferencesRequest
 */ export class ListLandscapeProgramReferencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeProgramReferencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeProgramReferencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeProgramReferencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeProgramReferencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeProgramReferencesRequest, "runtime", proto3);
_define_property(ListLandscapeProgramReferencesRequest, "typeName", "mono.datagateway.v1.ListLandscapeProgramReferencesRequest");
_define_property(ListLandscapeProgramReferencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramReferenceThread
 */ export class ProgramReferenceThread extends Message {
    static fromBinary(bytes, options) {
        return new ProgramReferenceThread().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramReferenceThread().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramReferenceThread().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramReferenceThread, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramReferenceThread, "runtime", proto3);
_define_property(ProgramReferenceThread, "typeName", "mono.datagateway.v1.ProgramReferenceThread");
_define_property(ProgramReferenceThread, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * No Program source rows, raw release body, operational history or finances.
 *
 * @generated from message mono.datagateway.v1.ProgramContextReference
 */ export class ProgramContextReference extends Message {
    static fromBinary(bytes, options) {
        return new ProgramContextReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramContextReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramContextReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramContextReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string library_item_id = 2;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string release_id = 3;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: int32 release_version = 4;
   */ _define_property(this, "releaseVersion", 0), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string summary = 6;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: repeated string capabilities = 7;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: string start_date = 8;
   */ _define_property(this, "startDate", ""), /**
   * A published end date is never a confirmed recompete date.
   *
   * @generated from field: string end_date = 9;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: google.protobuf.Timestamp released_at = 10;
   */ _define_property(this, "releasedAt", void 0), /**
   * @generated from field: bool can_open_delivery = 11;
   */ _define_property(this, "canOpenDelivery", false), /**
   * @generated from field: string contract_id = 12;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: mono.datagateway.v1.RegistryContractIdentity contract_identity = 13;
   */ _define_property(this, "contractIdentity", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramReferenceThread threads = 14;
   */ _define_property(this, "threads", []), /**
   * At most 20 permitted completion-date evidence records; never raw observations.
   *
   * @generated from field: repeated mono.datagateway.v1.ProgramContractEvidence contract_evidence = 15;
   */ _define_property(this, "contractEvidence", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramContextReference, "runtime", proto3);
_define_property(ProgramContextReference, "typeName", "mono.datagateway.v1.ProgramContextReference");
_define_property(ProgramContextReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "release_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "capabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "released_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "can_open_delivery",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "contract_identity",
            kind: "message",
            T: RegistryContractIdentity
        },
        {
            no: 14,
            name: "threads",
            kind: "message",
            T: ProgramReferenceThread,
            repeated: true
        },
        {
            no: 15,
            name: "contract_evidence",
            kind: "message",
            T: ProgramContractEvidence,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLandscapeProgramReferencesResponse
 */ export class ListLandscapeProgramReferencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeProgramReferencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeProgramReferencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeProgramReferencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeProgramReferencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramContextReference references = 1;
   */ _define_property(this, "references", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeProgramReferencesResponse, "runtime", proto3);
_define_property(ListLandscapeProgramReferencesResponse, "typeName", "mono.datagateway.v1.ListLandscapeProgramReferencesResponse");
_define_property(ListLandscapeProgramReferencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "references",
            kind: "message",
            T: ProgramContextReference,
            repeated: true
        }
    ]));
/**
 * Safe source/as-of projection. No values, quotes, locations or original JSON.
 *
 * @generated from message mono.datagateway.v1.ProgramContractEvidence
 */ export class ProgramContractEvidence extends Message {
    static fromBinary(bytes, options) {
        return new ProgramContractEvidence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramContractEvidence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramContractEvidence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramContractEvidence, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string evidence_id = 1;
   */ _define_property(this, "evidenceId", ""), /**
   * @generated from field: string observation_id = 2;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: string source = 3;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_version = 4;
   */ _define_property(this, "sourceVersion", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_at = 5;
   */ _define_property(this, "effectiveAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 6;
   */ _define_property(this, "retrievedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramContractEvidence, "runtime", proto3);
_define_property(ProgramContractEvidence, "typeName", "mono.datagateway.v1.ProgramContractEvidence");
_define_property(ProgramContractEvidence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "effective_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramFollowOnOptionsRequest
 */ export class ListProgramFollowOnOptionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramFollowOnOptionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramFollowOnOptionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramFollowOnOptionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramFollowOnOptionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string library_item_id = 2;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string release_id = 3;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: int32 release_version = 4;
   */ _define_property(this, "releaseVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramFollowOnOptionsRequest, "runtime", proto3);
_define_property(ListProgramFollowOnOptionsRequest, "typeName", "mono.datagateway.v1.ListProgramFollowOnOptionsRequest");
_define_property(ListProgramFollowOnOptionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "release_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramFollowOnOption
 */ export class ProgramFollowOnOption extends Message {
    static fromBinary(bytes, options) {
        return new ProgramFollowOnOption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramFollowOnOption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramFollowOnOption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramFollowOnOption, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * Linked to this canonical Program, including other releases/Landscapes.
   *
   * @generated from field: bool already_linked = 3;
   */ _define_property(this, "alreadyLinked", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramFollowOnOption, "runtime", proto3);
_define_property(ProgramFollowOnOption, "typeName", "mono.datagateway.v1.ProgramFollowOnOption");
_define_property(ProgramFollowOnOption, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "already_linked",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramFollowOnOptionsResponse
 */ export class ListProgramFollowOnOptionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramFollowOnOptionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramFollowOnOptionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramFollowOnOptionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramFollowOnOptionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramFollowOnOption opportunities = 1;
   */ _define_property(this, "opportunities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramFollowOnOptionsResponse, "runtime", proto3);
_define_property(ListProgramFollowOnOptionsResponse, "typeName", "mono.datagateway.v1.ListProgramFollowOnOptionsResponse");
_define_property(ListProgramFollowOnOptionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities",
            kind: "message",
            T: ProgramFollowOnOption,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveProgramFollowOnRequest
 */ export class SaveProgramFollowOnRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveProgramFollowOnRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveProgramFollowOnRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveProgramFollowOnRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveProgramFollowOnRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string library_item_id = 2;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string release_id = 3;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: int32 release_version = 4;
   */ _define_property(this, "releaseVersion", 0), /**
   * @generated from field: string retry_key = 5;
   */ _define_property(this, "retryKey", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * Empty means explicitly create; otherwise link this canonical Opportunity.
   *
   * @generated from field: string opportunity_id = 7;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveProgramFollowOnRequest, "runtime", proto3);
_define_property(SaveProgramFollowOnRequest, "typeName", "mono.datagateway.v1.SaveProgramFollowOnRequest");
_define_property(SaveProgramFollowOnRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "release_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "retry_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveProgramFollowOnResponse
 */ export class SaveProgramFollowOnResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveProgramFollowOnResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveProgramFollowOnResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveProgramFollowOnResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveProgramFollowOnResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramReferenceThread opportunity = 1;
   */ _define_property(this, "opportunity", void 0), /**
   * @generated from field: bool already_linked = 2;
   */ _define_property(this, "alreadyLinked", false), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string release_id = 4;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: int32 release_version = 5;
   */ _define_property(this, "releaseVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveProgramFollowOnResponse, "runtime", proto3);
_define_property(SaveProgramFollowOnResponse, "typeName", "mono.datagateway.v1.SaveProgramFollowOnResponse");
_define_property(SaveProgramFollowOnResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: ProgramReferenceThread
        },
        {
            no: 2,
            name: "already_linked",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "release_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
